import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_olo_pay_kiosk_event.js";
//#region src/bite_log_olo_pay_kiosk_event_helper.ts
var bite_log_olo_pay_kiosk_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 1: return "payment";
		case 2: return "payment-error";
		case 3: return "refund";
		case 4: return "refund-error";
		case 5: return "terminal-disconnected";
	}
}
//#endregion
export { bite_log_olo_pay_kiosk_event_helper_exports, name };

//# sourceMappingURL=bite_log_olo_pay_kiosk_event_helper.js.map